import React from "react";
import ReactNotifications, { store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import gql from "graphql-tag";
import { Subscription } from "react-apollo";
import { getUserToken } from "../../libs/authentication";
import Emitter from "../../libs/Events";

const NotificationSubscription = gql`
  subscription notification($token: String!) {
    SubscribeNotification(token: $token) {
      notification_type
      notification_text
      url
      shown_at
      user_code
      is_read
      timestamp_no
    }
  }
`;
function showNotification(title, message, url) {
  store.addNotification({
    title: title,
    message: message,
    type: "warning",
    container: "top-right",
    animationIn: ["animated", "fadeIn"],
    animationOut: ["animated", "fadeOut"],
    width: 400,
    // onRemoval: () => {
    //   if (url) this.props.history.push(url);
    // },
    dismiss: {
      duration: 30 * 1000,
      pauseOnHover: true
    },
    showIcon: true
  });
  Emitter.emit("push_notification");
}
export default function NotificationSubscriber(props) {
  return (
    <React.Fragment>
      <ReactNotifications />
      <Subscription
        subscription={NotificationSubscription}
        variables={{
          token: getUserToken() ?? ""
        }}
        shouldResubscribe={() => {}}
        onSubscriptionData={sub => {
          const data = sub?.subscriptionData?.data?.SubscribeNotification;
          //   console.log(data);
          showNotification(
            `New ${data.notification_type} Notification!`,
            data.notification_text,
            data.url
          );
          // console.log(data);
        }}
      />
    </React.Fragment>
  );
}
